@file:kotlin.js.JsExport
package com.narbase.letsgo.web.routing.domain.passenger.notifications
import com.narbase.letsgo.dto.core.KmmLong

import com.narbase.letsgo.router.EndPoint

object MarkNotificationAsSeenEndpoint :
    EndPoint<MarkNotificationAsSeenEndpoint.Request, MarkNotificationAsSeenEndpoint.Response>() {
    class Request(
        val notificationId: KmmLong,
    )

    class Response
}